import { OrderHistory } from "@/types/order-type";
import { apiClient } from "./api-client";
import { ProductVariant, TProductWithRelation } from "@/types/product-type";
import { AutoReplyMessage, Participant, QueueCustomer } from "@/types/fb-type";
import { PinnedVariantWithStock, RemovalOrderItemResult, SaleProductResponse } from "@/types/sale-type";

export async function productForSale(limit: number, offset: number, q: string, pinnedOnly?: boolean, onlyInStock?: boolean, sortColumn?: "stock_in_hand" | "sold_qty", sortDir?: "ASC" | "DESC", letter?: string | null) {
    const filterLetter = letter ? `&letter=${letter}` : '';
    const url = `/sale/products?limit=${limit}&offset=${offset}&q=${q}&pinnedOnly=${pinnedOnly}&onlyInStock=${onlyInStock}&sortColumn=${sortColumn}&sortDir=${sortDir}${filterLetter}`;
    const response = await apiClient.get<SaleProductResponse, {}>(url);
    return response;
}
export async function variantForSale(variantId: string) {
    const response = await apiClient.get<TProductWithRelation, {}>(`/sale/products/${variantId}`, {});
    return response;
}


export async function getListAutoReplies() {
    const response = await apiClient.get<AutoReplyMessage[], {}>(`/sale/products/auto-reply`, {});
    return response;
}
export async function getQueueCustomers() {
    const response = await apiClient.get<QueueCustomer[], {}>(`/sale/products/q-customers`, {});
    return response;
}
export async function pinProduct(variantId: string, productId: string) {
    const data = {
        variantId: variantId,
        productId: productId

    };
    const response = await apiClient.post<PinnedVariantWithStock[], {}>(`/sale/products/pin`, data);
    return response
}
export async function unPinProduct(variantId: string, productId: string) {
    const data = {
        variantId: variantId,
        productId: productId

    };
    const response = await apiClient.post<PinnedVariantWithStock[], {}>(`/sale/products/un-pin`, data);
    return response
}

export async function replyComment(commentId: string, content: string) {
    const data = {
        commentId,
        content

    };
    const response = await apiClient.post<{}, {}>(`/fb/live/reply`, data);
    return response
}
export async function updateProductVariantPrice(variantId: string, newPrice: number) {
    const data = {
        newPrice
    };
    const response = await apiClient.post<{}, {}>(`/product-variants/${variantId}/price`, data)
    return response
}
export async function pinVariants() {
    const response = await apiClient.get<PinnedVariantWithStock[], {}>(`/sale/products/pins`, {});
    return response;
}

export async function removeOrderItem(variantId: string, orderId: string) {
    const url = `/sale/products/order-items/${variantId}/remove`;
    const data = {
        orderId,
        variantId
    };
    const response = await apiClient.post<RemovalOrderItemResult, {}>(url, data);
    return response;
}

export async function unpinAllVariants() {
    const response = await apiClient.put<{}, {}>(`/sale/products/unpin-all`, {});
    return response;
}
export async function getOutOfStockToday() {
    const response = await apiClient.get<ProductVariant[], {}>(`/sale/out-of-stock`, {});
    return response;
}
export async function clearOutOfStockToday() {
    const response = await apiClient.post<{}, {}>(`/sale/out-of-stock/clear`, {});
    return response;
}

export async function searchProductVariants(searchQuery: string, limit: number = 20) {
    const url = `/sale/products?limit=${limit}&offset=0&q=${encodeURIComponent(searchQuery)}&pinnedOnly=false&onlyInStock=false`;
    const response = await apiClient.get<SaleProductResponse, {}>(url);
    return response;
}
export async function getVariantAlphabets() {
    const response = await apiClient.get<string[], {}>(`/sale/variants/alphabets`, {});
    return response;
}